export const options = [
  { value: 1, label: "Online" },
  { value: 2, label: "Offline" },
];
export const initialValues = {
  title: "",
  link: "",
  file: "",
  description: "",
  communityEventTypeId: "",
  eventFormat: "",
  promoted: false,
  fromClock: "",
  toClock: "",
  date: "",
};
